import ArrowIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import Button from 'components/Button/Button';
import Player from 'components/VideoPlayer';
import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import * as Styled from './styled';

const useStyles = makeStyles(() => ({
  videoContainer: {
    position: 'relative',
    display: 'inline-block',
    '& .unmute-button': {
      width: '100px',
      marginTop: 10,
      marginLeft: 10,
    },
  },
  overlay: {
    position: 'absolute',
    zIndex: 1,
    cursor: 'pointer',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundImage: "url('/assets/images/big-play-button.png')",
    backgroundSize: '20%',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  },
}));

const PromoVideo = ({}) => {
  const [t] = useTranslation('auth');
  const classes = useStyles();
  const [muted, setMuted] = useState(true);
  const videoRef = useRef();

  function unmutePlay() {
    videoRef.current.seekTo(0);
    setMuted(false);
  }

  return (
    <Styled.ReviewContainer>
      <Box className="embedsocial-reviews">
        <Box className1={classes.videoContainer}>
          <Player url={t('login_video_url')} />
        </Box>
        <Box mt={2}>
          <Typography paragraph variant="h4">
            {t('login_promo_video_title')}
          </Typography>
          <Typography paragraph color="text.secondary">
            {t('login_promo_video_subtitle')}
          </Typography>
          <Button
            component="a"
            href={t('login_promo_video_cta_url')}
            target="_blank"
            variant="contained"
            endIcon={<ArrowIcon />}
          >
            {t('login_promo_video_cta_text')}
          </Button>
        </Box>
      </Box>
    </Styled.ReviewContainer>
  );
};

export default PromoVideo;
